// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"6a5fd6f4","576":"7fd77155"}[chunkId] + ".chunk.css";
};